import Forestalia from "src/components/Projects/allProjectsData/Forestalia";
import defaultProjectData from "src/components/Projects/allProjectsData/default";

export const allProjectsData = {
  Forestalia,
};

export { defaultProjectData };
